import share_popup from './util/share_popup';

document.addEventListener('DOMContentLoaded', () => {
  share_popup('.btn-sns');
});


//////////////////
// WEBPACK FOOTER
// ./assets/js/app.js
// module id = 0
// module chunks = 0